import * as React from 'react'
import { connect } from 'react-redux'

import { Product } from 'even-ts-static'

import { MultiProductState } from 'embed/reducers'
import { SelectedProductView } from './index'

interface Props {
  availableProducts: Product[]
  selectedProduct: Product
}

const Container: React.FC<Props> = (props) => <SelectedProductView {...props} />

const mapStateToProps = (state: MultiProductState) => ({
  availableProducts: state.ui.availableProducts,
  selectedProduct: state.ui.selectedProduct,
})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Container)
